import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { PrInitiatorHelperService } from 'src/app/modules/pr-initiator/services/pr-initiator-helper.service';
import { AdminMasterEnum, IAdminMasterTab } from '../../models';
interface FileSize {
  file : File,
  formatSize : string
}
@Component({
  selector: 'app-master-popup',
  templateUrl: './master-popup.component.html',
  styleUrls: ['./master-popup.component.scss']
})
export class MasterPopupComponent implements OnInit {

  public title !: string;
  public masterTab !: IAdminMasterTab;
  public dropdownValue : any[] = [];
  public threshold !: string;
  public division_name !: string;
  public download_file_name!: string;
  public template_name!: string;
  public isOnBehalfSupplier : boolean = false;

  public onClose = new Subject<File | any[]>();

  // file variable
  uploadFiles : Array<FileSize> = [];  //As of now there is only one file supported, keeping array for future multiple file upload

  constructor(public bsModalRef: BsModalRef,
    private _helperService : PrInitiatorHelperService) { }

  ngOnInit(): void {
    if (this.title.toLowerCase() == 'po approvers') {
      this.download_file_name = 'ApproverGIDtemplate.xlsx'
      this.template_name = 'assets/templates/ApproverGIDtemplate.xlsx'
    } else if (this.title.toLowerCase() == 'po release strategy') {
      this.download_file_name = 'codesforreleasestrategyTemplate.xlsx'
      this.template_name = 'assets/templates/codesforreleasestrategyTemplate.xlsx'
    } else if (this.title.toLowerCase() == 'po threshold') {
      this.download_file_name = 'companycodeTemplate.xlsx'
      this.template_name = 'assets/templates/companycodeTemplate.xlsx'
    } else if (this.title.toLowerCase() == 'esn -- upload') {
      this.download_file_name = 'ESN_CODE_UPLOAD_TEMPLATE.xlsx'
      this.template_name = 'assets/templates/ESN_CODE_UPLOAD_TEMPLATE.xlsx'
    } else if (this.title.toLowerCase() == 'qes releaseCode') {
      this.download_file_name = 'QES_release_code_Template.xlsx'
      this.template_name = 'assets/templates/QESrelease_code.xlsx'
    } else if (this.title.toLowerCase() == 'qes threshold') {
      this.download_file_name = 'qes_threshold.xlsx'
      this.template_name = 'assets/templates/qes_threshold.xlsx'
    } else if (this.title.toLowerCase() == 'qes approver') {
      this.download_file_name = 'QES_Approver_Template.xlsx'
      this.template_name = 'assets/templates/QesMasterApprovers.xlsx'
    }  else if (this.title.toLowerCase() == 'esn service') {
      this.download_file_name = 'ServiceESNTemplate.xlsx'
      this.template_name = 'assets/templates/ServiceESNTemplate.xlsx'
    }  else if (this.title.toLowerCase() == 'payment term') {
      this.download_file_name = 'PAYMENT_TERM_DESCRIPTION.xlsx'
      this.template_name = 'assets/templates/PAYMENT_TERM_DESCRIPTION.xlsx'
    } else if (this.title.toLowerCase() == 'ehs'){
      this.download_file_name = 'EHS_Template.xlsx'
      this.template_name = 'assets/templates/Template EHS.xlsx'
    }else if (this.title.toLowerCase() == 'qes matrix') {
      this.download_file_name = 'QES_Matrix_Template.xlsx'
      this.template_name = 'assets/templates/HealthineersTemaplate_QESMatrix.xlsx'
    }else if (this.title.toLowerCase() == 'clause') {
      this.download_file_name = 'ClauseTemplate.xlsx'
      this.template_name = 'assets/templates/Clause_template.xlsx'
    } else if (this.title == AdminMasterEnum.COND_TYPE) {
      this.download_file_name = 'ConditionTypeTemplate.xlsx'
      this.template_name = 'assets/templates/conditioncode_template.xlsx'
    } else if (this.title == AdminMasterEnum.DOC_TYPE) {
      this.download_file_name = 'DocumentType_Template.xlsx'
      this.template_name = 'assets/templates/DocType.xlsx'
    } else if (this.title == AdminMasterEnum.GBK) {
      this.download_file_name = 'GBK.xlsx'
      this.template_name = 'assets/templates/GBK_template.xlsx'
    } else if (this.title == AdminMasterEnum.PACKING_CODE) {
      this.download_file_name = 'Packing_Template.xlsx'
      this.template_name = 'assets/templates/Packingcode_template.xlsx'
    }  else if (this.title == AdminMasterEnum.PARTNER_CODE) {
      this.download_file_name = 'PartnerCode_Template.xlsx'
      this.template_name = 'assets/templates/PartnerCode_emplate.xlsx'
    }  else if (this.title == AdminMasterEnum.SHIPPING_CODE) {
      this.download_file_name = 'Shipping_Code_Template.xlsx'
      this.template_name = 'assets/templates/ShippingCode_template.xlsx'
    } else if (this.title == AdminMasterEnum.TAX_CODE){
      this.download_file_name = 'TaxCode_Template.xlsx'
      this.template_name = 'assets/templates/TaxCode_template.xlsx'
    }else if (this.title == AdminMasterEnum.YA_PARTNER) {
      this.download_file_name = 'YA_Partner_Template.xlsx'
      this.template_name = 'assets/templates/YApartner_template.xlsx'
    } else if (this.title == AdminMasterEnum.SERVICE_MATERIAL_DESC) {
      this.download_file_name = 'SERVICE_MATERIAL_DESC.xlsx'
      this.template_name = 'assets/templates/ServiceMaterial-Template.xlsx'
    } else if (this.title == AdminMasterEnum.GL_ACCOUNT_MASTER) {
      this.download_file_name = 'GL Account MAsterData Template.xlsx'
      this.template_name = 'assets/templates/GlAccountTemplate.xlsx'
    } else if (this.title == AdminMasterEnum.COST_CENTER) {
      this.download_file_name = 'Cost Center Template.xlsx'
      this.template_name = 'assets/templates/CostcenterTemplate.xlsx'
    } else if (this.title == AdminMasterEnum.REPORTING_MANAGER_DETAILS) {
      this.download_file_name = 'ReportingManagerApprovalmasterTemp.xlsx'
      this.template_name = 'assets/templates/ReportingManagerApprovalmasterTemp.xlsx'
    } else if (this.title == AdminMasterEnum.CURRENCY) {
      this.download_file_name = 'Currency_Template.xlsx'
      this.template_name = 'assets/templates/currencyTemplate.xlsx'
    }else if (this.title == AdminMasterEnum.PLANT_COMPANY_MASTER) {
      this.download_file_name = 'PlantCompanyMaster.xlsx'
      this.template_name = 'assets/templates/PlantCompanyMaster.xlsx'
    }else if(this.title == AdminMasterEnum.PO_CONFIRMATION_VENDOR_MASTER) {
      this.download_file_name = 'POConfirmationVendorTemplate.xlsx'
      this.template_name = 'assets/templates/POConfirmationVendorTemplate.xlsx'
    }
  }

  public onUploadFile(event : any) : void {
    [...event.target.files].forEach((file : File)=>{
      this.uploadFiles.push({file, formatSize : this._helperService.formatFileSize(file.size) })
    });
    console.log(this.uploadFiles);
  }

  public updateInfo(): void {
    const outputData = this.masterTab.isUpload 
      ? this.uploadFiles[0].file 
      : this.masterTab.keyName === 'plant_code'
        ? { dropdownValue: this.dropdownValue, isOnBehalfOfSupplier: this.isOnBehalfSupplier }
        : this.masterTab.keyName !== 'division'
          ? this.dropdownValue
          : [{ division_name: this.division_name, threshold: this.threshold }];
  
    this.closeModal(outputData);
  }
  

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public blockInvalidChar(e: any) {
    ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
  };

  handleCheckboxChange(e: any){
    this.isOnBehalfSupplier = e.target.checked
  }

}
